import { useContext } from 'react';
import { useQuery } from 'react-query';
import { apiGet } from 'api';
import AuthContext from 'context/auth-context';

const getPermissionVariables = async (token) => {
  const url = 'admin/permission_variables';
  const data = await apiGet({ url, token });
  return data;
};

export function useAdminPermissionVariables({ options } = {}) {
  const token = useContext(AuthContext);
  const queryFn = () => getPermissionVariables(token);
  const queryKey = 'admin-permission-variables';
  return useQuery(queryKey, queryFn, { ...options });
}
